// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jAXFt","controls":"styles_controls__3KTp2","charLimit":"styles_charLimit__3Ffcy","input":"styles_input__qyKZk","send":"styles_send__2-Cvi"};